<!--
 * @Author: qinmengyuan
 * @Date: 2024-04-11 11:22:38
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-04-11 14:04:08
 * @FilePath: \onetab\src\components\ModelBtn.vue
-->
<template>
  <div class="model-btn" @click="handleChange">
    <i class="iconfont icon-onetabmoshiqiehuan"></i>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { theme } from '@/store/theme';
const emits = defineEmits(['handleChange']);
const handleChange = () => {
  emits('handleChange');
};
</script>
<style lang="scss" scoped>
.model-btn {
  display: inline-flex;
  height: 48px;
  min-width: 48px;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  border-radius: 12px;
  background: rgba(26, 26, 26, 0.08);
  background-blend-mode: luminosity;
  backdrop-filter: blur(60px);
  justify-content: center;
  cursor: pointer;
  .iconfont {
    font-size: 24px;
    @include font_color('base-bg-color-09');
  }

  &:hover {
    @include background_color('base-bg-color-app-04');
  }
}
</style>
